import React, { useState } from 'react';
import { FormContainer } from '../../../styled';
import { fetchApiData } from '../../../Utils/ApiCalls';
import { REQUEST_STATUS_ENUM } from '../../../Constants/Constants';
import { PUT_REQUEST_ON_HOLD, RESUME_ON_HOLD_REQUEST } from '../../../urls';
import { Button, Input, RadioGroup, showToast, Typography } from '@attentive-platform/stem-ui';

const RequestOnHold = () => {
  const [requestId, setRequestId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(REQUEST_STATUS_ENUM.ON_HOLD);

  const handleSubmit = async () => {
    if (!requestId.trim()) {
      showToast('Please enter a request ID', 'error');
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        request_id: requestId.trim()
      };

      const endpoint = status === REQUEST_STATUS_ENUM.ON_HOLD ? PUT_REQUEST_ON_HOLD : RESUME_ON_HOLD_REQUEST;
      const response = await fetchApiData({
        data,
        endpoint: endpoint,
        apiRequest: 'POST'
      });

      if (response.error) {
        showToast(response.error, 'error');
      } else {
        setRequestId('');
        showToast(response.data.message, 'success');
        setStatus(REQUEST_STATUS_ENUM.ON_HOLD);
      }
    } catch (error) {
      showToast(error, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormContainer>
        <Input
          label='Request ID'
          type='text'
          value={requestId}
          placeholder='Enter request ID'
          onChange={e => setRequestId(e.target.value)}
          fullWidth
          required
        />

      <div className='flex items-center gap-4 justify-between'>
        <Typography variant='body3' className='font-medium'>
          Status
        </Typography>
        <RadioGroup
          row
          value={status}
          onChange={(event, newValue) => setStatus(newValue)}
          radioGroup={[
            {
              label: 'On hold',
              value: REQUEST_STATUS_ENUM.ON_HOLD
            },
            {
              label: 'In progress',
              value: REQUEST_STATUS_ENUM.IN_PROGRESS
            }
          ]}
        />
      </div>

      <div className='flex justify-end'>
        <Button
          color='primary'
          size='medium'
          variant='contained'
          onClick={handleSubmit}
          disabled={isLoading || !requestId.trim()}
          className='text-base'>
          {isLoading ? 'Updating...' : 'Update request status'}
        </Button>
      </div>
    </FormContainer>
  );
};

export default RequestOnHold;
